import { render, staticRenderFns } from "./DemoAlert.vue?vue&type=template&id=255a0e75&scoped=true&lang=pug"
import script from "./DemoAlert.vue?vue&type=script&lang=ts"
export * from "./DemoAlert.vue?vue&type=script&lang=ts"
import style0 from "./DemoAlert.vue?vue&type=style&index=0&id=255a0e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a0e75",
  null
  
)

export default component.exports